import { render, staticRenderFns } from "./crearPassword.vue?vue&type=template&id=458b0c28&"
import script from "./crearPassword.vue?vue&type=script&lang=js&"
export * from "./crearPassword.vue?vue&type=script&lang=js&"
import style0 from "./crearPassword.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "../../../App.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports